export default angular.module('category', []).constant('carCategories',
	[
		{name: 'M1', value: 1},
		{name: 'N1', value: 2},
		{name: 'Tříkolová mot. vozidla', value: 3},
		{name: 'Ostatní', value: 4},
	]
).name



// WEBPACK FOOTER //
// build/services/category.js